<template>
  <div>
    <My-new-nav ref="header" menuTheme="dark"></My-new-nav>
    <div class="topBanner">
      <div class="pageTitle">
        <div class="title">医疗行业革命者</div>
        <div class="subTitle">让医疗价值回归，让医疗更加温暖</div>
      </div>
    </div>
    <div class="card">
      <div class="cardTop">
        <div class="cardTitle">医智诺集团</div>
        <div class="cardDesc">搭建医疗新生态</div>
      </div>
      <p>医智诺集团是香港上市公司弘毅文化集团（HK00419，原华谊腾讯公司）旗下的医疗集团与控股子公司，作为一家致力于打造新医疗价值服务观的科技企业，医智诺一直将前沿的人工智能技术应用于医疗领域。</p>
      <p>医智诺集团战略定位为医疗产业数字化运营领跑者，聚焦于医疗产业，持续专注于医疗企业数字化转型服务，通过线上线下一体化联动为企业提供全发展周期商业化的数字化运营解决方案，以自主研发“苁蓉”数字化运营（DT）系统等多款产品并引入AI能力，赋能医生、患者、药房、药企等端口的有效串联及全场景私域化运营。</p>
      <p>医智诺集团始终围绕 TOB战略，致力于搭建全场景化的医疗服务平台，布局全产业医疗服务生态圈，总部位于苏州，研发中心位于古都西安，运营中心总部位于上海，目前已在全国建立3个事业部，业务覆盖 29 个省市自治区。作为医疗产业数字化运营领跑者，医智诺集团秉持与合作伙伴“共生、共渡、共赢”的理念，助力医疗企业数字化运营转型，赋能企业价值链全流程。</p>
      <div class="video">
        <video ref="video" class="video-cont" :controls="videoControls" src="https://video.echartnow.com/sv/2633573c-183545037f3/2633573c-183545037f3.mp4">
          <p class="message">您的浏览器不支持播放视频</p>
        </video>
        <div class="video-play" v-show="!isPlay">
          <img src="../../assets/image/icon-play.png" alt="" @click="operateVideo">
        </div>
      </div>
    </div>
    <div class="card img_bg">
      <div class="cardTop">
        <div class="cardTitle">医智诺集团</div>
        <div class="cardDesc">搭建医疗新生态</div>
      </div>
      <div class="fourSub">
        <div class="subCard">
          <div class="listPic num1"></div>
          <div class="listTitle">上市公司</div>
          <div class="listDesc">香港上市公司</div>
          <div class="listDesc">弘毅文化集团（HK00419）</div>
          <div class="listDesc">控股子公司</div>
        </div>
        <div class="subCard">
          <div class="listPic num2"></div>
          <div class="listTitle">合法合规</div>
          <div class="listDesc">互联网诊疗资质</div>
          <div class="listDesc">医药／耗材全功能牌照</div>
          <div class="listDesc">CA认证在内的12+合法资质</div>
        </div>
        <div class="subCard">
          <div class="listPic num3"></div>
          <div class="listTitle">全国布局</div>
          <div class="listDesc">已在全国建立3个事业部</div>
          <div class="listDesc">业务覆盖29个省市自治区</div>
        </div>
        <div class="subCard">
          <div class="listPic num4"></div>
          <div class="listTitle">技术创新</div>
          <div class="listDesc">21+软件著作权</div>
          <div class="listDesc">布局全产业医疗服务生态圈</div>
          <div class="listDesc">搭建全场景化医疗服务平台</div>
        </div>
      </div>
    </div>
    <Information />
  </div>
</template>

<script>
import Information from "@/views/mobile/Information.vue";

export default {
  components: {Information},
  data() {
    return {
      videoControls: false,
      isPlay: false,
    }
  },
  methods: {
    operateVideo() {
      this.$refs.video.play()
      this.videoControls = true;
      this.isPlay = true;
    },
  }
}
</script>

<style lang="scss" scoped>
.topBanner{
  padding-bottom: 53.33%;
  position: relative;
  background-image: url("../../assets/image/Mobile/groupIntroduce/top_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  .pageTitle{
    padding-left: 36px;
    position: absolute;
    top: 40%;
    .title{
      font-size: 72px;
      font-family: YouSheBiaoTiHei;
      color: #FFFFFF;
      line-height: 93px;
      letter-spacing: 15px;
      text-shadow: 0px 0px 6px rgba(6,58,148,0.5);
    }
    .subTitle{
      font-size: 30px;
      line-height: 45px;
      font-weight: bold;
      color: #FFFFFF;
      letter-spacing: 12px;
      text-shadow: 0px 0px 6px rgba(6,58,148,0.5);
    }
  }
}
.card{
  padding: 80px 36px;
  background-color: black;
  color: #FFFFFF;
  .cardTop{
    position: relative;
    margin-bottom: 60px;
    &::after{
      content: '';
      display: block;
      position: absolute;
      width: 84px;
      height: 18px;
      background: #0D6EFD;
      opacity: 0.9;
    }
  }
  .cardTitle{
    font-size: 54px;
    font-weight: bold;
    line-height: 69px;
    letter-spacing: 6px;
  }
  .cardDesc{
    font-size: 30px;
    font-weight: 500;
    line-height: 60px;
    letter-spacing: 8px;
  }
  & > p{
    font-size: 42px;
    font-weight: 400;
    line-height: 72px;
    letter-spacing: 4px;
    margin-bottom: 60px;
  }
  .video {
    width: 100%;
    position: relative;
    .video-cont{
      width: 100%;
      height: 100%;
    }
    .video-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      img {
        width: 210px;
        height: 210px;
        cursor: pointer;
      }
    }
  }
  &.img_bg{
    background-image: url("../../assets/image/Mobile/groupIntroduce/mid_bg.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .fourSub{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .subCard{
      width: 41%;
      padding-bottom: 50px;
      background: #062D67;
      box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.04);
      opacity: 0.7;
      margin: 30px 38px;
      text-align: center;
      .listPic{
        margin: 60px auto 0;
        width: 49.29%;
        padding-bottom: 40.14%;
        background-repeat: no-repeat;
        background-size: contain;
        &.num1{
          background-image: url('../../assets/image/Mobile/groupIntroduce/list_bg1.png');
        }
        &.num2{
          background-image: url('../../assets/image/Mobile/groupIntroduce/list_bg2.png');
        }
        &.num3{
          background-image: url('../../assets/image/Mobile/groupIntroduce/list_bg3.png');
        }
        &.num4{
          background-image: url('../../assets/image/Mobile/groupIntroduce/list_bg4.png');
        }
      }
      .listTitle{
        font-size: 42px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 80px;
      }
      .listDesc{
        font-size: 30px;
        font-weight: 400;
        color: #ACC7ED;
        line-height: 45px;
      }
    }
  }
}
</style>
